import { Checkbox } from '@ab-core/checkbox';
import { getTestIdProp } from '@ab-core/testing';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import type { ComparableProductType } from '../state';
import { isSkuInComparableList, toggleComparableProduct } from '../state';
import { showComparison } from '../utils';

export const ComparisonCheckbox: FC<ComparableProductType> = (props) => {
    const isProductInComparableList = isSkuInComparableList(props.sku);
    const isVisible = showComparison();
    const [isChecked, setIsChecked] = useState(isProductInComparableList);

    const [stateReset1, setStateReset1] = useState(false);
    const [stateReset2, setStateReset2] = useState(false);

    const toggleToCompare = () => {
        toggleComparableProduct(props);
        setStateReset1(!stateReset1);
    };
    useEffect(() => {
        setIsChecked(!isProductInComparableList);
        setStateReset2(!stateReset2);
    }, [stateReset1]);

    useEffect(() => {
        setIsChecked(isProductInComparableList);
    }, [stateReset2, isProductInComparableList]);

    if (!isVisible) {
        return <></>;
    }

    return (
        <Checkbox
            {...getTestIdProp('product-card-comparison-checkbox')}
            onChange={toggleToCompare}
            checked={isChecked}
            label="Artikel vergleichen"
        />
    );
};
